import { render } from "./MainHeaderSortMenu.vue?vue&type=template&id=7c5fa8d2&scoped=true&ts=true"
import script from "./MainHeaderSortMenu.vue?vue&type=script&lang=ts"
export * from "./MainHeaderSortMenu.vue?vue&type=script&lang=ts"

import "./MainHeaderSortMenu.vue?vue&type=style&index=0&id=7c5fa8d2&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5fa8d2"]])

export default __exports__